// extracted by mini-css-extract-plugin
export default {"EmptyBody":"Empty_EmptyBody__Y0Khd","EmptyTitle":"Empty_EmptyTitle__gxdV8","EmptySubTitle":"Empty_EmptySubTitle__xUv9g","CreateNewIssueButton":"Empty_CreateNewIssueButton__7olYV"};